"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var scenicRouter = {
  path: '/scenic-spot',
  component: _layout.default,
  redirect: '/scenic-spot/list',
  name: 'ScenicSpot',
  meta: {
    title: '门票',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/index'));
      });
    },
    name: 'ScenicSpotList',
    meta: {
      title: '门票列表',
      icon: ''
    }
  }, {
    path: 'scenery-list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/scenery'));
      });
    },
    name: 'SceneryList',
    meta: {
      title: '景点列表',
      icon: ''
    }
  }, {
    path: 'viewarea-list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/viewArea'));
      });
    },
    name: 'ViewareaList',
    meta: {
      title: '景区列表',
      icon: ''
    }
  }, {
    path: 'yearcard-list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/yearcard'));
      });
    },
    name: 'yearcardList',
    meta: {
      title: '年卡列表',
      icon: ''
    }
  }, {
    path: 'packageticket-list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/packageticket'));
      });
    },
    name: 'packageticketList',
    meta: {
      title: '套票列表',
      icon: ''
    }
  }, {
    path: 'cdkey',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/cdkey/index'));
      });
    },
    name: 'Cdkey',
    meta: {
      title: '卡密管理',
      icon: ''
    }
  }, {
    //id:卡密库id
    path: 'cdkey/creatCdkey/:id?/:name?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/cdkey/creatCdkey'));
      });
    },
    name: 'creatCdkey',
    meta: {
      title: '卡密添加',
      noCache: true,
      activeMenu: "/scenic-spot/cdkey"
    },
    hidden: true
  }, {
    path: 'classify',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/category/index'));
      });
    },
    name: 'ProductClassify',
    meta: {
      title: '门票分类',
      icon: ''
    }
  }, {
    path: 'attr',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/attr/index'));
      });
    },
    name: 'ProductAttr',
    meta: {
      title: '门票规格',
      icon: ''
    }
  }, {
    path: 'comment',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/comment/index'));
      });
    },
    name: 'ProductComment',
    meta: {
      title: '门票评论',
      icon: ''
    }
  }, {
    //id:门票id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集门票(1是，2不是),scenic-spotType:门票类型
    path: 'list/creatProduct/:id?/:isDisabled',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/creatProduct/index'));
      });
    },
    name: 'creatProduct',
    meta: {
      title: '门票添加',
      noCache: true,
      activeMenu: "/scenic-spot/list"
    },
    hidden: true
  }, {
    //id:门票id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集门票(1是，2不是),scenic-spotType:门票类型
    path: 'list/creatProduct/addyear/:id?/:isDisabled',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/creatProduct/add-year'));
      });
    },
    name: 'creatProduct',
    meta: {
      title: '年卡添加',
      noCache: true,
      activeMenu: "/scenic-spot/yearcard-list"
    },
    hidden: true
  }, {
    //id:门票id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集门票(1是，2不是),scenic-spotType:门票类型
    path: 'list/creatProduct/addtp/:id?/:isDisabled',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/creatProduct/add-tp'));
      });
    },
    name: 'creatProduct',
    meta: {
      title: '套票添加',
      noCache: true,
      activeMenu: "/scenic-spot/packageticket-list"
    },
    hidden: true
  }, {
    path: 'guarantee/group',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/guarantee/index'));
      });
    },
    name: 'ProductGuarantee',
    meta: {
      title: '保障服务组合',
      icon: ''
    }
  }, {
    path: 'label',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/scenic-spot/label/index'));
      });
    },
    name: 'ProductLabel',
    meta: {
      title: '门票标签',
      icon: ''
    }
  }]
};
var _default = exports.default = scenicRouter;